<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

       <div class="content" v-else>
           <h1>Import prodejů</h1>




           <v-layout class="table-items" >
               <v-data-table

                   locale="cs"
                       :headers="headers"
                       :items="items"
                       :search="search"
                       :loading="false"
                       item-key="name"
                       :items-per-page="30"
                       sort-by="created_at"
                       :sort-desc="true"
                       :mobile-breakpoint='0'
                       class="elevation-1 full-width frankjoy-table"
               >
                   <template slot="body" slot-scope="props">
                       <tbody>
                       <tr v-for="item in props.items" :key="item.id" >

                               <td class="">
                                   <span v-if="item.image" class="image-table image-table--photo" :style="'background-image:url('+item.image+')'"></span>
                                   <span v-else class="image-table"></span>
                               </td>
                               <td class="">{{item.audiobook_id}}</td>
                               <td class="">{{item.audiobook_name}}</td>
                               <td class="bold">
                                   <span class="actual-price">
                                       <span v-if="item.price">
                                        {{item.price}} Kč
                                       </span>
                                       <span v-else>
                                           0 Kč
                                       </span>
                                   </span>
                                   <br>
                                   <span class="small normal"><span class="small">Bez DPH</span> {{item.price_no_dph}} Kč</span>
                               </td>
                               <td class="small">{{formatCreatedAt(item.created_at)}}</td>

                       </tr>
                       <div v-if="props.items.length == 0" class="text-no-results">
                           <p>Žádná audiokniha nebyla nalezena</p>
                       </div>
                       </tbody>
                   </template>
                   <template slot="footer" slot-scope="totals">
                       <div class="table-footer"  v-bind:class="{'footer--no-results': totals.props.pagination.pageStop === 0}">
                           <div class="table-footer__text">
                               Počet audioknih na stránce
                           </div>
                           <div class="table-footer__pages">
                               <span v-if="totals.props.pagination.pageStop > 0"><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart + 1}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                               <span v-else><span class="table-footer__pages-bold">{{totals.props.pagination.pageStart}}-{{totals.props.pagination.pageStop}}</span> z {{totals.props.pagination.itemsLength}}</span>
                           </div>
                       </div>
                   </template>
               </v-data-table>


           </v-layout>

       </div>






    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    import VueJsonToCsv from 'vue-json-to-csv'

    export default {
        name: 'SalesImport',
        components: {
            VueJsonToCsv
        },



        data() {
            return {

                grouped: false,
                loaded: false,
                searchGrouped: '',
                search: '',
                headers: [
                    //  { text: '', value: '',  align: 'left',sortable: false },
                    { text: '', value: 'image', sortable: false,  align: 'left',  },
                    { text: 'ID', value: 'audiobook_id',  align: 'left',  },
                    { text: 'Audiokniha', value: 'audiobook_name',  align: 'left',  },
                    { text: 'Cena', value: 'price',  align: 'left',  },
                    { text: 'Koupeno', value: 'created_at',  align: 'left',  },
                ],
                items: [],
                itemsAll: [],
                publisher: null,
                dialogValidTo: false,
                dialogValidFrom: false,
                data: {},
                validationSuccess: true,
            }
        },

        created() {


            this.checkData();




        },
        computed: {
            ...mapState(['profile','import']),



        },
        mounted(){

        },
        methods: {
            checkData(){
                if(!this.import){
                    this.$router.go(-1);
                }
                this.loaded = true;
                this.validationSuccess = true;
            },

            formatCreatedAt(date){
                if(date){
                    return moment.unix(date).format('D.M.YYYY - HH:mm');
                }else{
                    return null;
                }

            },

        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
